module.exports = __webpack_public_path__ + "img/redact.710a6592.png";